import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { from, BehaviorSubject } from 'rxjs';
import Job from '../interfaces/Job';

@Injectable({
  providedIn: 'root',
})
export class JobService {
  jobs$ = new BehaviorSubject([]);
  
  constructor(private afs: AngularFirestore) {}

  getJobs() {
    const jobRef: AngularFirestoreCollection<any> = this.afs.collection('jobs');
    return from(jobRef.valueChanges());
  }

  createJob(jobData: Job) {
    // return this.afs.collection('jobs').add(jobData);
    return new Promise((resolve, reject) => {
      this.afs.collection('jobs').add(jobData).then((dRef) => {
        dRef.update({ id: dRef.id }).then(() => {
          resolve(dRef.id);
        });
      });
    })
  }

  getCurrentJob(id) {
    const jobRef: AngularFirestoreCollection<any> = this.afs.collection('jobs', ref => ref.where('id', '==', id))
    return from(jobRef.valueChanges());
  }

  getCurrentUserOwnedJobs(uid) {
    // let jobs = []
    // if (userJobs && userJobs.length) {
    //   userJobs.forEach(up => {
    //     const userJobsRef: AngularFirestoreCollection<any> = this.afs.collection('jobs', ref => ref.where('id', '==', up))
    //     jobs.push(from(userJobsRef.valueChanges()))
    //   })
    //   this.jobs$.next(jobs);
    //   return this.jobs$;
    // }
    const userJobsRef: AngularFirestoreCollection<any> = this.afs.collection('jobs', (ref) =>
      ref.where('owner', '==', uid)
    );
    return from(userJobsRef.valueChanges());
  }

  updateJob(jobId, d) {
    const jobRef: AngularFirestoreDocument<any> = this.afs.doc(`jobs/${jobId}`);
    return jobRef.update(d);
  }

  deleteJob(jobId) {
    const jobRef: AngularFirestoreDocument<any> = this.afs.doc(`jobs/${jobId}`);
    return jobRef.delete();
  }
}
